import useMonolithApiQuery, { UseMonolithApiQueryOptions } from '@/hooks/api/useMonolithApiQuery';

type AIConversationMessageCommon = {
  userMessage: string;
  turnSequence: number;
  turnId: string;
  status: 'running' | 'failed' | 'successful';
};
type AIConversationMessageSuccessful = AIConversationMessageCommon & {
  status: 'successful';
  assistantResponse: string;
  hasResponsePayload?: boolean;
  turnDurationSeconds: number;
};
type AIConversationMessageInProgress = AIConversationMessageCommon & {
  status: 'running';
  assistantResponse: null;
  turnDurationSeconds: null;
};
type AIConversationMessageFailed = AIConversationMessageCommon & {
  status: 'failed';
};
type AIConversationMessage =
  AIConversationMessageSuccessful | AIConversationMessageInProgress | AIConversationMessageFailed;
export type AIConversationMessageFinished = AIConversationMessageSuccessful | AIConversationMessageFailed;
type AIConversationResponse = AIConversationMessage[];

export const getBuildAIConversation = ({ buildSlug }: { buildSlug: string }) => {
  return `/api/builds/${buildSlug}/ai_conversation`;
};

export const getCiConfigExpertConversation = ({ ciConfigSlug }: { ciConfigSlug: string }) => {
  return `/apps/${ciConfigSlug}/agent_runs/conversation?ai_run_type=ci-config-expert`;
};

export type AIConversationParams =
  { buildSlug: string; ciConfigSlug?: never } | { buildSlug?: never; ciConfigSlug: string };

const useAIConversation = (
  params: AIConversationParams,
  opts?: UseMonolithApiQueryOptions<AIConversationResponse, unknown>,
) => {
  const url = params.buildSlug
    ? getBuildAIConversation({ buildSlug: params.buildSlug })
    : getCiConfigExpertConversation({ ciConfigSlug: params.ciConfigSlug as string });

  const queryKey = params.buildSlug
    ? ['build', params.buildSlug, 'ai_conversation']
    : ['ci-config-expert', params.ciConfigSlug as string, 'conversation'];

  return useMonolithApiQuery<AIConversationResponse, unknown>(queryKey, url, opts);
};

export default useAIConversation;
